import React from 'react'

export default function Techmid() {
  var arr_div = ["cz_0", "cz_1", "cz_2", "cz_3"];

  return (
    <div className="TechMid">
      <div className="craziest_slider">
        <div id="cz_" className="same_c">
          <h1 id="h_cz_">
            {" "}
            OpenAI comes from industry experts <br /> who want to bring AI to
            the masses.
          </h1>
          <button id="b_cz">Check More </button>
        </div>
        {/* <div id="cz_0" className="same_c"></div>
          <div id="cz_1" className="same_c"></div>
          <div id="cz_2" className="same_c"></div>
          <div id="cz_3" className="same_c"></div> */}
        {arr_div.map((e, i) => {
          return <div id={e} key={i} className="same_c"></div>;
        })}
      </div>
    </div>
  );
}
